<template>
  <div v-if="shouldShowTitle" class="cart-title">
    <h3 class="title">{{ titleText }}</h3>
  </div>
</template>

<script>
import { useCartStore } from "@/store/cart";

export default {
  name: "CartTitle",
  props: {
    pageType: {
      type: String,
      required: true,
    },
  },
  computed: {
    cart() {
      return useCartStore().cart;
    },
    shouldShowTitle() {
      if (window.productDetails?.limitCartTo1Item) {
        return false;
      }
      return this.pageType === "order-page" && this.cart?.items?.length > 0;
    },
    titleText() {
      return this.cart?.items?.length === 1 ? this.$t("labels.myChoice") : this.$t("labels.myChoices");
    },
  },
};
</script>
